import React from 'react';
import { usePrefs } from 'ws-scripts/modules/common';
import { useSelector } from 'react-redux';
import { setClassNames } from 'ddc-classnames-js';

const Footer = () => {
	const kbbCustomerRatings = useSelector((state) => state.ratings);
	const { useHorizontalStyle, useInverseTextColor } = usePrefs();

	const {
		numberOfReviews: totalReviews,
		generationStartYear: startYear,
		generationEndYear: endYear
	} = kbbCustomerRatings;

	const determineStartEndYear = (y1, y2) => {
		const currentYear = new Date().getFullYear();
		const start = String(y1 === 'current' ? currentYear : y1);
		const end = String(y2 === 'current' ? currentYear : y2);
		const separator = !start || !end ? '' : '–';
		return start === end ? start : `${start}${separator}${end}`;
	};

	const enableHorizontalLayout = useHorizontalStyle === 'true';
	const textMutedColor =
		useInverseTextColor === 'true' ? 'text-muted-inverse' : 'text-muted';

	let textLinkColor = '';
	if (useInverseTextColor === 'true') {
		textLinkColor = enableHorizontalLayout
			? 'text-muted-inverse'
			: 'text-link-inverse';
	} else if (enableHorizontalLayout) {
		textLinkColor = 'text-muted';
	}

	const footerClasses = [
		'kbb-footer',
		'mt-3',
		enableHorizontalLayout ? 'ddc-font-size-xsmall' : ''
	];

	const privacyClasses = [
		'kbb-privacy-link',
		textLinkColor,
		enableHorizontalLayout ? 'ml-3' : '',
		enableHorizontalLayout ? 'text-decoration-underline' : ''
	];

	return (
		<div className={setClassNames(footerClasses)}>
			{totalReviews && startYear && endYear && (
				<span>
					<span className={`kbb-footer-text ${textMutedColor}`}>
						Based on {totalReviews} consumer ratings for{' '}
						{determineStartEndYear(startYear, endYear)} models.
					</span>
					{!enableHorizontalLayout && (
						<span
							className={`${textMutedColor} separator`}
							aria-hidden="true"
						>
							&nbsp;|&nbsp;
						</span>
					)}
				</span>
			)}

			<a
				className={setClassNames(privacyClasses)}
				target="_blank"
				rel="noopener noreferrer"
				href="https://www.kbb.com/company/privacy-policy/"
			>
				Privacy{' '}
			</a>
		</div>
	);
};

export default Footer;
